export class Analytics {
  private readonly commonAnalyticsData = {
    NonInteractionEvent: "0",
    ElementType: "Standard",
  };

  private readonly enrichWithCommonInfo = (value: any): any => {
    const combinedValue = {
      ...this.commonAnalyticsData,
      ...value,
    };
    const enrichFn =
      window.AnalyticsTactical?.Sports?.localHelpers?.enrichWithCommonInfo(
        value,
      );
    return enrichFn ? enrichFn : combinedValue;
  };

  public trackGAEvent = (key: string, value: any) => {
    try {
      window.AnalyticsTactical?.Helpers?.sendData(
        key,
        this.enrichWithCommonInfo({
          ...this.commonAnalyticsData,
          ...value,
        }),
      );
    } catch (err) {
      console.error(`Tracking event failed with error`, { err, value });
    }
  };
}
